import React, { FC } from 'react'
import { Box, Button, Typography } from '@mui/material'
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import CloseIcon from '@mui/icons-material/Close'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'
import { Filehelper } from '../Filehelper'


interface FileUploadSectionProps {
  contentType: string
  image: File | string | null
  document: File | string | null
  onImageSelect: (e: React.ChangeEvent<HTMLInputElement>) => void
  onDocumentSelect: (e: React.ChangeEvent<HTMLInputElement>) => void
  onRemoveImage: () => void
  onRemoveDocument: () => void
}

const FileUploadSection: FC<FileUploadSectionProps> = ({
  contentType,
  image,
  document,
  onImageSelect,
  onDocumentSelect,
  onRemoveImage,
  onRemoveDocument,
}) => {
  return (
    <Box sx={{ pt: 1 }}>
      {/* Upload Buttons */}
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <Button
          variant="contained"
          component="label"
          endIcon={<AddPhotoAlternateIcon />}
          sx={{
            backgroundColor: 'secondary.main',
            color: '#fff',
            textTransform: 'none',
            px: 3,
            py: 1,
            fontSize: '14px',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: 'secondary.dark',
              boxShadow: 'none',
            },
          }}
        >
          Subir imagen
          <input hidden accept="image/*" type="file" onChange={onImageSelect} />
        </Button>

        {contentType === 'comunicado' && (
          <Button
            variant="contained"
            component="label"
            endIcon={<FileUploadIcon />}
            sx={{
              backgroundColor: 'primary.500',
              color: '#fff',
              textTransform: 'none',
              px: 3,
              py: 1,
              fontSize: '14px',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: 'primary.dark',
                boxShadow: 'none',
              },
            }}
          >
            Subir documento
            <input
              hidden
              accept=".pdf,.doc,.docx,.xls,.xlsx"
              type="file"
              onChange={onDocumentSelect}
            />
          </Button>
        )}
      </Box>

      {/* Selected Files */}
      <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {image && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              p: 1.5,
              backgroundColor: '#f3f4f6',
              borderRadius: 1,
              border: '1px solid #e5e7eb',
            }}
          >
            <AddPhotoAlternateIcon sx={{ color: 'secondary.main', fontSize: 20 }} />
            <Typography
              variant="body2"
              sx={{
                flex: 1,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: '13px',
              }}
            >
              {Filehelper.getFileName(image)}
            </Typography>
            <Box
              component="button"
              type="button"
              onClick={onRemoveImage}
              sx={{
                border: 'none',
                backgroundColor: 'transparent',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                padding: 0.5,
                borderRadius: '50%',
                '&:hover': {
                  backgroundColor: '#e5e7eb',
                },
              }}
            >
              <CloseIcon sx={{ fontSize: 18, color: '#6b7280' }} />
            </Box>
          </Box>
        )}

        {contentType === 'comunicado' && document && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              p: 1.5,
              backgroundColor: '#eff6ff',
              borderRadius: 1,
              border: '1px solid #dbeafe',
            }}
          >
            <InsertDriveFileIcon sx={{ color: 'primary.main', fontSize: 20 }} />
            <Typography
              variant="body2"
              sx={{
                flex: 1,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: '13px',
              }}
            >
              {Filehelper.getFileName(document)}
            </Typography>
            <Box
              component="button"
              type="button"
              onClick={onRemoveDocument}
              sx={{
                border: 'none',
                backgroundColor: 'transparent',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                padding: 0.5,
                borderRadius: '50%',
                '&:hover': {
                  backgroundColor: '#dbeafe',
                },
              }}
            >
              <CloseIcon sx={{ fontSize: 18, color: '#6b7280' }} />
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default FileUploadSection
